import React, { useState } from 'react';

import './Forgotten-Password.css';

async function sendResetEmail(credentials) {
  return await fetch(`${process.env.REACT_APP_API_URL}/user/send-reset-email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  });
}

export default function ForgottenPassword() {
  const [username, setUserName] = useState();

  const handleSubmit = async e => {
    e.preventDefault();
    await sendResetEmail({
      username,
    });

    window.location.href = '/';
  };

  return (
    <div className="login-wrapper">
      <h1>Send Reset Email</h1>
      <form onSubmit={handleSubmit}>
        <label>
          <p>Username</p>
          <input type="text" onChange={e => setUserName(e.target.value)} />
        </label>
        <div>
          <button type="submit">Send Reset Email</button>
        </div>
      </form>
    </div>
  );
}

ForgottenPassword.propTypes = {};